<script>
import * as m from '@app/paraglide/messages.js';
import { preventDefault } from 'svelte/legacy';
import {
    fade
} from 'svelte/transition';
import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    playerState
} from '@app/store/playerStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    v4 as uuidv4
} from 'uuid';

import _Event from '@cclib/classes/event.js';
import _EventGroup from '@cclib/classes/eventGroup.js';
import tcLib from '@cclib/lib/timecode.js'
let eventGroup = $state(getSelectedEventGroup(["subtitle", "translation", "audio description"])),
    segmentationOption = $state("quantity"), //time, quantity, manual
    numberOfSegments = $state(3),
    userSegments = $state([{
        id: uuidv4(),
        start : "00:00:00:00",
        end : "00:00:00:00"
    }]);

function insertUserSegment(){
    userSegments = [...userSegments, {
        id: uuidv4(),
        start : "00:00:00:00",
        end : "00:00:00:00"
    }];
}

function removeUserSegment(){
    userSegments = userSegments.slice(0,-1);
}

function removeAllUserSegments(){
    userSegments = [{
        id: uuidv4(),
        start : "00:00:00:00",
        end : "00:00:00:00"
    }];
}

function validateTc(e, index, tcType) {
    userSegments[index][tcType] = tcLib.tcValidate(e.target.value, projectState.frameRate, projectState.dropFrame);
}

function getSelectedEventGroup(validTypes) {
    let evGroup = eventGroupState[projectState.selected];
    if (evGroup){
        if (validTypes.indexOf(evGroup.type) > -1) {
            return evGroup.id;
        } else {
            return false;
        }
    } else {
        return false;
    }    
}

function segmentEventGroups() {
    let segmentId = 1;
    let selectedEventGroup = eventGroupState.find(evGroup =>{
        return eventGroup === evGroup.id;
    });

    if (segmentationOption === "quantity"){
        let avgNumberEventsPerGroup = Math.floor(selectedEventGroup.events.length/numberOfSegments) || 1;
        selectedEventGroup.events.forEach((event,count) =>{
            if (count%avgNumberEventsPerGroup === 0 && segmentId <= numberOfSegments){
                eventGroupState.push({...(new _EventGroup({
                    ...selectedEventGroup, 
                    events : [], 
                    name : "Segment - "+segmentId++
                }))});
            }

            eventGroupState[eventGroupState.length-1].events = [...eventGroupState[eventGroupState.length-1].events, {...(new _Event(event))}];
        });
    } else if (segmentationOption === "time"){
        let duration = playerState.duration || selectedEventGroup.events[selectedEventGroup.events.length-1].end;
        if (!duration){
            toast.push(m.segment_event_group_no_duration_toast(), {classes: ['toast-danger']});

            return;
        }

        let avgDurationPerEventGroup = Math.floor(duration/numberOfSegments) || 1;
        let maxStart = avgDurationPerEventGroup;
        eventGroupState.push({...(new _EventGroup({
            ...selectedEventGroup, 
            events : [], 
            name : "Segment - "+segmentId++
        }))});
        selectedEventGroup.events.forEach(event =>{
            if (event.start>=maxStart && segmentId <= numberOfSegments){
                eventGroupState.push({...(new _EventGroup({
                    ...selectedEventGroup, 
                    events : [], 
                    name : "Segment - "+segmentId++
                }))});

                maxStart+=avgDurationPerEventGroup;
            }

            eventGroupState[eventGroupState.length-1].events = [...eventGroupState[eventGroupState.length-1].events, {...(new _Event(event))}];
        });
    } else {
        if (userSegments.length === 0){
            toast.push(m.segment_event_group_no_segments_toast(), {classes: ['toast-danger']});

            return;
        }
        let minStartTime, maxStartTime, segmentEvents = [];
        userSegments.forEach(segment =>{
            eventGroupState.push({...(new _EventGroup({
                ...selectedEventGroup, 
                events : [], 
                name : m.segment_event_group_segment_prefix()+" - "+segmentId++
            }))});

            minStartTime = tcLib.tcToSec(segment.start, projectState.frameRate, projectState.dropFrame);
            maxStartTime = tcLib.tcToSec(segment.end, projectState.frameRate, projectState.dropFrame);
            segmentEvents = selectedEventGroup.events.filter(event =>{
                return event.start >= minStartTime && event.start < maxStartTime;
            })

            segmentEvents.forEach(event =>{
                eventGroupState[eventGroupState.length-1].events = [...eventGroupState[eventGroupState.length-1].events, {...(new _Event(event))}];
            });
        });
    }
    toast.push(m.segment_event_group_complete_toast(), {classes: ['toast-success']});
    insertHistoryAction({
        name: m.segment_event_group_action_name(), //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
    hideModal();
}
</script>

<div transition:fade={{duration: 100}} class="modal {modalState.selected === 'segmentEventGroup' ? 'show d-block' : ''}" role="dialog" aria-labelledby="segmentEventGroupTitle" tabindex="-1" id="SegmentEventGroupModal">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="segmentEventGroupTitle">{m.segment_event_group_title()} <i class="bi bi-info-circle small" role="img" aria-label={m.common_information()} title={m.segment_event_group_description()}></i></h4>
                <button type="button" class="btn-close" id="closeSegmentModal" aria-label={m.segment_event_group_close_label()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(segmentEventGroups)} aria-label={m.segment_event_group_form_label()}>
                    <div class="mb-3">
                        <label class="form-label" for="eventGroupSelect">{m.segment_event_group_source_label()}</label>
                        <select class="form-select" id="eventGroupSelect" bind:value={eventGroup} aria-label={m.segment_event_group_source_aria_label()}>
                            {#each eventGroupState as eventGroupOption}
                            <option value={eventGroupOption.id}>{eventGroupOption.name}</option>
                            {/each}
                        </select>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="segmentationSelect">{m.segment_event_group_option_label()}</label>
                        <select class="form-select" id="segmentationSelect" bind:value={segmentationOption} aria-label={m.segment_event_group_option_aria_label()}>
                           <option value="time">{m.segment_event_group_by_time()}</option>
                           <option value="quantity">{m.segment_event_group_by_quantity()}</option>
                           <option value="manual">{m.segment_event_group_manual()}</option>
                        </select>
                        {#if segmentationOption === "time"}
                            <small class="form-text text-muted"><i class="bi bi-info-circle"></i> {m.segment_event_group_by_time_help()}</small> 
                        {:else if segmentationOption === "quantity"}
                            <small class="form-text text-muted"><i class="bi bi-info-circle"></i> {m.segment_event_group_by_quantity_help()}</small>
                        {:else if segmentationOption === "manual"}
                            <small class="form-text text-muted"><i class="bi bi-info-circle"></i> {m.segment_event_group_manual_help()}</small>
                        {/if}
                    </div>
                    {#if segmentationOption === "manual"}
                        <div class="d-flex align-items-center mb-2">
                            <p class="lead text-warning mb-0">{m.segment_event_group_user_segments_label()}</p>
                            <span class="ms-3">
                                <div class="btn-group btn-group-sm" role="group" aria-label={m.segment_event_group_segment_controls_label()}>
                                    <button type="button" class="btn btn-light" id="insertSegmentBtn" onclick={insertUserSegment} aria-label={m.segment_event_group_insert_segment_label()}><i class="bi bi-plus-lg" aria-hidden="true"></i></button>
                                    <button type="button" class="btn btn-outline-dark" id="removeSegmentBtn" onclick={removeUserSegment} aria-label={m.segment_event_group_remove_segment_label()} disabled={userSegments.length === 0}><i class="bi bi-dash-lg" aria-hidden="true"></i></button>
                                </div>
                                <button type="button" class="btn btn-sm btn-outline-danger ms-2" id="clearSegmentsBtn" onclick={removeAllUserSegments} aria-label={m.segment_event_group_clear_all_label()}>{m.segment_event_group_clear_all_button()}</button>
                            </span>
                        </div>
                        {#each userSegments as userSegment, index (userSegment.id)}
                            <div class="row">
                                <div class="input-group input-group-sm col">
                                    <div class="input-group input-group-sm">
                                      <span class="input-group input-group-sm-text">{index+1}</span>
                                    </div>
                                    <input type="text" class="form-control col" onblur={(e) => validateTc(e,index,"start")} onkeyup={e=>e.key==='Enter' && validateTc(e,index,"start")} onfocus={(e)=>{e.target.select()}} bind:value={userSegment.start}>
                                    <input type="text" class="form-control col" onblur={(e) => validateTc(e,index,"end")} onkeyup={e=>e.key==='Enter' && validateTc(e,index,"end")} onfocus={(e)=>{e.target.select()}} bind:value={userSegment.end}>
                                </div>                       
                            </div>
                        {/each}
                    {:else}
                        <div class="mb-3">
                            <label class="form-label" for="numberOfSegments">{m.segment_event_group_number_of_segments_label()}</label>
                            <input type="number" class="form-control" id="numberOfSegments" min="1" step="1" bind:value={numberOfSegments} aria-label={m.segment_event_group_number_input_aria_label()}>
                        </div>
                    {/if}
                </form>
            </div>
            <div class="modal-footer"><button class="btn btn-primary" type="button" id="segmentBtn" disabled={!eventGroup} onclick={segmentEventGroups} aria-label={m.segment_event_group_segment_button_label()}>{m.segment_event_group_segment_button()}</button></div>
        </div>
    </div>
</div>
